export const messages = {
  locate: { id: 'reverseGeocodeButton.locate', defaultMessage: 'Paikanna' },
}
